import Maintenance from './Maintenance'
import { AccessType } from '../../auth/accessControlService'

export default {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: '/maintenance',
      component: Maintenance,
      accesses: [AccessType.ANNONYMOUS, AccessType.ADMINISTRATION],
      routes: [
        {
          exact: true,
          path: '/maintenance',
          component: Maintenance,
        },
      ],
    },
  ],
}
